"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";
import { env } from "~/env.mjs";

export default function GlobalError({ error }) {
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (env.NEXT_PUBLIC_NODE_ENV === "development") {
        // Mirror what Next's overlay does, but make it consistent across boundaries.
        console.error(error);
        return;
      }
      Sentry.captureException(error);
    }
  }, [error]);

  return <NextError statusCode={error.statusCode} />;
}
